"use client";

import { Expand } from "lucide-react";
import { shouldShow } from "@/types/utils";
import { FormatNumberWithSeparator, ConvertToPersianNumbers } from "@/utils/utils";
import AdCard from "@/components/ad-card";

const formatPrice = (value: string | number | null | undefined) =>
  ConvertToPersianNumbers(FormatNumberWithSeparator(value));

const DemandCard = ({ ad }: { ad: any }) => {
  const isSold = Boolean(ad.is_sold);

  return (
    <AdCard
      ad={ad}
      media={
        <div className="relative w-full overflow-hidden h-10">
          {isSold ? (
            <span className="absolute bottom-1 right-0 rounded-sm border-2 border-red-600 bg-white px-2 py-1 text-sm font-bold text-red-600">
              معامله شد
            </span>
          ) : (
            shouldShow(ad.listing_type) && (
              <span className="absolute bottom-1 right-0 rounded-sm bg-[#F97066] px-2 py-1 text-sm text-white">
                {ad.listing_type}
              </span>
            )
          )}
        </div>
      }
      pricing={
        <>
          {(shouldShow(ad.max_mortgage_amount) ||
            shouldShow(ad.min_mortgage_amount)) && (
              <div className="text-base font-extrabold text-gray-700">
                <span className="ml-1 text-xs font-normal text-gray-500">
                  ودیعه:
                </span>
                <span className="text-indigo-700">
                  {[
                    shouldShow(ad.min_mortgage_amount)
                      ? formatPrice(ad.min_mortgage_amount)
                      : null,
                    shouldShow(ad.max_mortgage_amount)
                      ? formatPrice(ad.max_mortgage_amount)
                      : null,
                  ]
                    .filter(Boolean)
                    .join(" - ")}
                </span>
                <span className="mr-1 text-xs font-normal text-gray-500">
                  تومان
                </span>
              </div>
            )}

          {(shouldShow(ad.min_rent_amount) ||
            shouldShow(ad.max_rent_amount)) && (
              <div className="text-base font-extrabold text-indigo-700">
                <span className="ml-1 text-xs font-normal text-gray-500">
                  ماهانه:
                </span>
                <span className="text-indigo-700">
                  {[
                    shouldShow(ad.min_rent_amount)
                      ? formatPrice(ad.min_rent_amount)
                      : null,
                    shouldShow(ad.max_rent_amount)
                      ? formatPrice(ad.max_rent_amount)
                      : null,
                  ]
                    .filter(Boolean)
                    .join(" - ")}
                </span>
                <span className="mr-1 text-xs font-normal text-gray-500">
                  تومان
                </span>
              </div>
            )}

          {(shouldShow(ad.min_price) || shouldShow(ad.max_price)) && (
            <div className="text-base font-extrabold text-indigo-700">
              {[
                shouldShow(ad.min_price)
                  ? formatPrice(ad.min_price)
                  : null,
                shouldShow(ad.max_price)
                  ? formatPrice(ad.max_price)
                  : null,
              ]
                .filter(Boolean)
                .join(" - ")}
              <span className="mr-1 text-xs font-normal text-gray-500">
                تومان
              </span>
            </div>
          )}
        </>
      }
      area={
        shouldShow(ad.min_total_area) ? (
          <div className="mt-auto pt-3 flex items-center gap-2 text-xs font-medium text-gray-400 border-t border-gray-50">
            <Expand className="h-3.5 w-3.5" />
            {ConvertToPersianNumbers(`${ad.min_total_area} - ${ad.max_total_area}`)} متر مربع
          </div>
        ) : null
      }
    />
  );
};

export default DemandCard;
